import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { Dialog, TableRow, Typography } from '@mui/material';
import { GridOverlay } from '@mui/x-data-grid';
import { accountTypeArray } from 'store/constant';

export const AccountTypeData = [
	{ label: 'All In One', value: 1 },
	{ label: 'DAP', value: 6 },
	{ label: 'TFSA', value: 7 },
	{ label: 'RRSP', value: 8 },
	// { label: 'TFSA', value: 0 },
	{ label: 'SpRRSP', value: 9 },
	{ label: 'LIRA', value: 10 },
	{ label: 'RRIF', value: 11 },
	{ label: 'LIF', value: 13 },
	{ label: 'LRSP', value: 20 },
	{ label: 'Corporate Margin', value: 21 },
	{ label: 'Individual Single RESP', value: 22 },
	{ label: 'Individual Family RESP', value: 23 },
	{ label: 'Joint Single RESP', value: 24 },
	{ label: 'Joint Family RESP', value: 25 },
	{ label: 'Joint Non-Registered', value: 26 }
];

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.body}`]: {
		fontSize: 12
		// padding: 10
	},
	'&:nth-of-type(odd)': {
		backgroundColor: '#484257',
		color: theme.palette.common.white
		// padding: 10
	},
	'&:nth-of-type(even)': {
		backgroundColor: '#34303e',
		color: theme.palette.common.white
		// padding: 10
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0
	}
}));

export const StyledTableCellData = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.body}`]: {
		fontSize: 13
	},

	'&:nth-of-type(odd)': {
		// backgroundColor: '#efefef',
		color: '#2a2a2a'
	},
	'&:nth-of-type(even)': {
		// backgroundColor: '#f5f5f5',
		// color: '#2a2a2a'
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0
	}
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
	// '&:nth-of-type(odd)': {
	// 	backgroundColor: theme.palette.action.hover
	// },
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0
	}
}));


export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogContent-root': {
		padding: theme.spacing(2),
	},
	'& .MuiDialogActions-root': {
		padding: theme.spacing(1),
	},
}));

export const formatDateDMY = (timestamp) => {
	const date = new Date(timestamp);
	return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric' }).format(date);
};

export const formatDateMonthYear = (dateString) => {
	const date = new Date(dateString);

	const day = date.getUTCDate();
	const month = date.toLocaleString('default', { month: 'long' });
	const year = date.getUTCFullYear();

	// Get the day suffix (st, nd, rd, th)
	const getDaySuffix = (day) => {
		if (day > 3 && day < 21) return 'th'; // 11th, 12th, 13th, etc.
		switch (day % 10) {
			case 1: return 'st';
			case 2: return 'nd';
			case 3: return 'rd';
			default: return 'th';
		}
	};

	const dayWithSuffix = `${day}${getDaySuffix(day)}`;

	return `${dayWithSuffix} ${month}-${year}`;
};


export const getAccountTypeLabel = (value) => {
	const found = accountTypeArray.find(item => item.value === value);
	return found ? found.label : '';
};

export default function NoDataFoundMessage() {
	return (
		<GridOverlay>
			<Typography variant="h6" color="textSecondary">
				No record found
			</Typography>
		</GridOverlay>
	);
};

export const NoDataFoundMessageBS = () => {
	return (
		<div className="col-12 text-center mt-5">
			<div
				style={{
					padding: "40px",
					background: "#f0f3f5",
					borderRadius: "12px",
					border: "1px solid #d6e0ea",
					fontSize: "18px",
					color: "#4b5563",
				}}
			>
				<img
					src="images/no-data-found.png"
					alt="No data"
					style={{ width: "120px", opacity: 0.8 }}
				/>
				<p className="mt-3 mb-0">No data found</p>
			</div>
		</div>
	)
};
